<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("PRODUCTS.EDIT_PRODUCT") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <product-form
              :loading="loading"
              :productData="product"
              :formErrors="formErrors"
              @productSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductForm from "./partials/ProductForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultProduct from "./defaultProduct";

export default {
  layout: "DashboardLayout",

  components: { ProductForm },

  mixins: [alertLeave],

  data() {
    return {
      product: cloneDeep(defaultProduct),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("products/get", id);
        this.product = this.$store.getters["products/product"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Products" });
    },

    viewProduct() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Product",
        params: { id: this.product.id },
      });
    },

    async handleSubmit(product) {
      this.loading = true;
      const productData = cloneDeep(product);

      try {
        await this.$store.dispatch("products/update", productData);
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.PRODUCT_UPDATED"),
        });
        this.viewProduct();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
